<template>
    <v-menu
        v-model="menu"
        :close-on-content-click="false">
        <template v-slot:activator="{ on }">
            <v-btn v-on="on" icon class="btn--plain" @click="focusSearch"> <!-- @click.stop="" -->
                <v-icon>search</v-icon>
            </v-btn>
        </template>

        <v-card min-width="300px">
            <v-list class="pa-0">
                <v-list-item class="pa-0" dense>
                    <v-list-item-content class="pa-0">
                        <v-text-field
                            v-model="search"
                            ref="searchbox"
                            label="Search"
                            outlined
                            solo
                            clearable
                            dense
                            append-icon="search"
                            hide-details></v-text-field>
                    </v-list-item-content>
                </v-list-item>
            </v-list>

            <v-divider></v-divider>

            <v-list class="pt-0 scroll-search">
                <template v-for="group in filteredSearch">
                    <v-subheader :key="group.value" dense>{{ group.value }}</v-subheader>
                    <v-list-item v-for="item in group.items" :key="group.value+'|'+item.id" :to="group.url + item.id" @click="closeMenu">
                        <v-list-item-title>{{ item.name }}</v-list-item-title>
                    </v-list-item>
                </template>
                <v-list-item v-if="!filteredSearch.length">
                    <v-list-item-title>No results found</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-card>
    </v-menu>
</template>

<script>
    export default {
        data() {
            return {
                menu: false,
                search: ''
            }
        },
        computed: {
            filteredSearch() {
                let productGroup = {
                        value: 'Products',
                        items: [],
                        url: '/product/'
                    },
                    customerGroup = {
                        value: 'Customers',
                        items: [],
                        url: '/customer/'
                    },
                    supplierGroup = {
                        value: 'Suppliers',
                        items: [],
                        url: '/supplier/'
                    },
                    returnArr = [];

                productGroup.items = this.filterAndSort('products');
                customerGroup.items = this.filterAndSort('customers');
                supplierGroup.items = this.filterAndSort('suppliers');

                if(customerGroup.items.length)
                    returnArr.push(customerGroup);

                if(productGroup.items.length)
                    returnArr.push(productGroup);
					
                if(supplierGroup.items.length)
                    returnArr.push(supplierGroup);
                
                return returnArr;
            }
        },
        methods: {
            closeMenu() {
                this.search = '';
                this.menu = false;
            },
            filterAndSort(type) {
                let items = [],
                    search = this.search ? this.search.toLowerCase() : null,
					storeName = type === 'suppliers' ? 'customers' : type;

                this.$store.state[storeName].forEach(item => {
                    let name = item.name.toLowerCase();
                        item = Object.assign({ match: 0 }, item);

					if((type === 'customers' && item.assignment_type !== 'order') || (type === 'suppliers' && item.assignment_type !== 'purchase-order')) {
						return;
					}
                    if(!search)
                        item.match = 1;
                    else if(name === search)
                        item.match = 1;
                    else if(name.startsWith(search))
                        item.match = 2;
                    else if(name.includes(search))
                        item.match = 3;
                    if(item.match)
                        items.push(item);
                });

                items.sort((a,b) => {
					return (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0);
                }).sort((a,b) => {
					return (a.match > b.match) ? 1 : ((b.match > a.match) ? -1 : 0);
                }).slice(0, 7);

                return items;
            },
            focusSearch() {
                setTimeout(() => this.$refs.searchbox.$refs.input.focus(), 100);
            }
        }
    }
</script>

<style lang="scss" scoped>
    .scroll-search{
        max-height: calc(100vh - 70px);
        overflow: auto;
    }
</style>